<script>
import { h, resolveComponent } from 'vue';

export default {
  name: 'cGridViewCol',
  data() {
    return {};
  },
  computed: {
    labelSz() {
      let val;
      if (this.labelSize === 'small') {
        val = 90;
      } else if (this.labelSize === 'medium') {
        val = 120;
      } else if (this.labelSize === 'large') {
        val = 170;
      } else if (this.labelSize === 'non') {
        val = 0;
      }
      return val;
    }
  },
  props: {
    col: {
      type: Number,
      default: undefined
    },
    label: {
      type: String,
      default: ''
    },
    labelSize: {
      type: String,
      validator: function (value) {
        return ['non', 'small', 'medium', 'large'].indexOf(value) !== -1;
      },
      default: 'medium'
    },
    childLen: {
      type: Number,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: undefined
    },
    valueType: {
      type: String,
      validator: function (value) {
        return ['text', 'comp'].indexOf(value) !== -1;
      },
      default: 'comp'
    },
    contentStyle: {
      type: Object,
      default: () => {}
    }
  },
  inject: ['parentsCols'],
  methods: {},
  render() {
    const { col, label, labelSz, required, childLen, parentsCols, help, valueType, contentStyle } =
      this;

    const legoIcon = resolveComponent('lego-icon');
    const legoTooltip = resolveComponent('lego-tooltip');
    const fieldHelp =
      help &&
      h('span', { class: 'help' }, [
        h(legoIcon, {
          icon: 'info',
          size: 16,
          iconType: 'df',
          id: 'manual'
        }),
        h(legoTooltip, { top: true, mouseOver: true }, [help])
      ]);

    const labelSec = h(
      'div',
      {
        class: {
          'c-grid-view-col-label': true
        },
        style: {
          width: labelSz + 'px'
        }
      },
      [
        this.$slots.label
          ? this.$slots.label()
          : h(
              'span',
              {
                class: {
                  'c-grid-view-col-label-text': true
                }
              },
              [
                label,
                required &&
                  h(
                    'span',
                    {
                      class: {
                        required: true
                      }
                    },
                    ['*']
                  ),
                childLen &&
                  h(
                    'span',
                    {
                      class: {
                        'child-len': true
                      }
                    },
                    [`(${childLen})`]
                  )
              ]
            ),
        fieldHelp
      ]
    );

    const content = h(
      'div',
      {
        class: {
          'c-grid-view-col-content': true,
          'content-text': valueType === 'text'
        },
        style: {
          ...contentStyle
        }
      },
      [this.$slots.default()]
    );

    const percent = 100 / parentsCols;

    return h(
      'div',
      {
        class: {
          'c-grid-view-col': true
        },
        style: {
          width: col ? percent * col + '%' : percent + '%'
        }
      },
      [labelSec, content]
    );
  }
};
</script>
<style lang="scss" scoped>
.c-grid-view-col {
  min-height: 32px;
  margin: 10px 0;
  display: flex;
  padding: 0 35px;

  &-label {
    display: flex;
    font-size: 14px;
    line-height: 32px;
    color: $color--ui01;
    font-weight: 700;

    .help {
      margin-left: 6px;
      margin-top: 2px;
    }

    .required {
      color: $color--status--error;
      font-weight: 700;
      font-size: 14px;
      margin-left: 4px;
    }

    .child-len {
      color: $color--primary;
      margin-left: 2px;
    }
  }

  &-content {
    flex: 1;

    &.content-text {
      padding: 4px 0;
      line-height: 24px;
    }
  }
}
</style>
